import type { RefObject } from 'react';
import { useEffect, useRef, useState } from 'react';

import { useLazyLoadSection } from 'hb-builder/contexts/LazyLoadSectionContext';

export const useIntersectionObserver = (
  sectionRef: RefObject<HTMLDivElement>,
  itemId: string | undefined,
) => {
  const { lastSectionId, onDisplayNextSection } = useLazyLoadSection();
  const [isSectionAlreadyObserved, setIsSectionAlreadyObserved] =
    useState(false);
  const observerRef = useRef<IntersectionObserver>(null);

  useEffect(() => {
    if (observerRef) {
      // @ts-expect-error reassign ref
      observerRef.current = new IntersectionObserver(
        (entries) => onDisplayNextSection(entries, isSectionAlreadyObserved),
        {
          root: null,
          rootMargin: '0px',
        },
      );

      const currentRef = sectionRef?.current;

      if (itemId === lastSectionId) {
        setIsSectionAlreadyObserved(true);

        currentRef &&
          !isSectionAlreadyObserved &&
          observerRef.current.observe(currentRef);
      } else {
        setIsSectionAlreadyObserved(false);

        currentRef &&
          isSectionAlreadyObserved &&
          observerRef.current.unobserve(currentRef);
      }
    }

    return () => {
      if (observerRef?.current) {
        observerRef.current?.disconnect();
      }
    };
  }, [lastSectionId]);
};
